import { connect } from 'react-redux';
import { LinkInner } from './component';
import { selectCurrentOrigin } from '../../../ReduxStorage/location/selectors';
import { makeSelectOriginForAction } from '../../../ReduxStorage/Institutions/CustomDomains/selectors';

export const Link = connect(
  () => {
    let currentTo;
    let selectOriginForAction;
    return (state, { to }) => {
      if (to !== currentTo) {
        currentTo = to;
        selectOriginForAction = makeSelectOriginForAction(to);
      }
      return {
        currentOrigin: selectCurrentOrigin(state),
        destinationOrigin: selectOriginForAction(state),
      };
    };
  },
  () => ({})
)(LinkInner);
